import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-200 p-4 mt-8">
      <p className="text-center"></p>
    </footer>
  );
};

export default Footer;